var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 23.375C11.2832 23.375 12.3332 22.325 12.3332 21.0417H7.6665C7.6665 22.325 8.7165 23.375 9.99984 23.375ZM16.9998 16.375V10.5417C16.9998 6.96 15.0982 3.96167 11.7498 3.16833V2.375C11.7498 1.40667 10.9682 0.625 9.99984 0.625C9.0315 0.625 8.24984 1.40667 8.24984 2.375V3.16833C4.91317 3.96167 2.99984 6.94833 2.99984 10.5417V16.375L0.666504 18.7083V19.875H19.3332V18.7083L16.9998 16.375ZM14.6665 17.5417H5.33317V10.5417C5.33317 7.64833 7.09484 5.29167 9.99984 5.29167C12.9048 5.29167 14.6665 7.64833 14.6665 10.5417V17.5417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.284eb5cfb99b4306e1d6f5b1896de7be.svg";
export { ForwardRef as ReactComponent };